export default __webpack_public_path__ + "static/media/dc-robin.ea4afe99.jpg";